document.addEventListener('DOMContentLoaded', function() {
  // Greek letter combinations to target
  const greekOrgs = [
    'ΦΒΣ', 'ΚΑΨ', 'ΦΝΠ', 'ΑΦΑ', 'ΩΨΦ', 
    'ΙΦΘ', 'ΔΣΘ', 'ΣΓΡ', 'ΖΦΒ', 'ΓΦΔ'
  ];
  
  // Function to wrap Greek letters in span
  function wrapGreekLetters(node) {
    if (node.nodeType === 3) { // Text node
      let text = node.textContent;
      let modified = false;
      
      // Replace Greek letter combinations
      greekOrgs.forEach(org => {
        if (text.includes(org)) {
          text = text.replace(new RegExp(org, 'g'), `<span class="greek-font">${org}</span>`);
          modified = true;
        }
      });
      
      if (modified) {
        const temp = document.createElement('div');
        temp.innerHTML = text;
        const fragment = document.createDocumentFragment();
        while (temp.firstChild) {
          fragment.appendChild(temp.firstChild);
        }
        node.parentNode.replaceChild(fragment, node);
      }
    } else if (node.nodeType === 1 && node.nodeName !== 'SCRIPT' && node.nodeName !== 'STYLE') {
      // Element node - recursively process children
      Array.from(node.childNodes).forEach(child => wrapGreekLetters(child));
    }
  }
  
  // Process the entire body
  wrapGreekLetters(document.body);
});